import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    bar: false,
    title: '中税网通',
    // APIURLS:'https://www.zswtbj.com/zswt/App/',//服务器后台数据连接路径
    CSSCAPIURL: 'http://192.168.10.149:6565/api/',//财税书城后台数据连接路径
    APIURLS:'http://192.168.10.112:9800/App/',//后台数据连接路径
    path: '/',
  },
  mutations: {
  },
  actions: {
  },
});